import { render, staticRenderFns } from "./Welcomebox.vue?vue&type=template&id=10e56245&"
import script from "./Welcomebox.vue?vue&type=script&lang=js&"
export * from "./Welcomebox.vue?vue&type=script&lang=js&"
import style0 from "./Welcomebox.vue?vue&type=style&index=0&id=10e56245&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports